import "./polyfill";

import { qs, qsAll } from "./dom-helpers";

import Header from "./modules/Header";
import Modals from "./modules/Modals";
import smoothAnchors from "./smooth-anchors";
import CasesSlider from "./modules/CasesSlider";
import Forms from "./modules/Forms";
import ToTopButton from "./modules/ToTopButton";

class Main {
  constructor() {
    this.forms = qsAll(".form");
    this._run();
  }

  _run() {
    try {
      this._registerGlobalObjects();
      this._registerForms();
      new Header();
      new Modals();
      new Forms();
      new CasesSlider();
      new ToTopButton();
      // eslint-disable-next-line new-cap
      // new smoothAnchors();
    } catch (e) {
      console.error(e); // eslint-disable-line
    }
  }

  _registerGlobalObjects() {
    window.qs = qs;
    window.qsAll = qsAll;
  }

  _registerForms() {
    this.forms.forEach((el) => new Forms(el));
  }
}

document.addEventListener("DOMContentLoaded", () => new Main());
